import { useState, useEffect } from 'react';

/**
 * Hook to detect online/offline status
 */
export const useOffline = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // Show success message when coming back online
        setWasOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  return { isOnline, wasOffline };
};

/**
 * Hook to sync data when coming back online
 */
export const useOnlineSync = (syncFn) => {
  const { isOnline, wasOffline } = useOffline();

  useEffect(() => {
    if (isOnline && wasOffline && syncFn) {
      syncFn();
    }
  }, [isOnline, wasOffline, syncFn]);

  return { isOnline };
};















